import React from 'react';
import SectionBanner from '../../components/Banner';
import ReqDemoAndSignupSection from '../../components/req_demo_or_signup_section';
import { Col, Container, Row } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { CustomTypoH1, CustomTypoH5 } from '../../helper/headings';
// Css
import './contact.css';
import AppNavBar from '../../helper/appbar';
const ContactPage = () => {
  const navigateBook = () => window.open('https://bookings@gokardinal.com', "_blank");
  const navigateSupport = () => window.open("https://support@gokardinal.com", "_blank");
  const navigateSales = () => window.open("https://business@gokardinal.com", "_blank");
  const navigateLinkedin = () => window.open("https://www.linkedin.com/company/kardinalinc/", "_blank");
  const navigateTwitter = () => window.open("https://twitter.com/gokardinal", "_blank");
  const navigateInstagram = () => window.open("https://instagram.com/gokardinal", "_blank");
  const navigateFacebook = () => window.open("https://facebook.com/gokardinal", "_blank");

  return (
    <div>
      <AppNavBar navType={"_green"} />
      <SectionBanner
        title={`Contact`}
        tagline={`We would love to hear from you. Have any questions? Feel free reach out.`}
      />

      <section className='contact-page-section'>
        <Container>
          <Row>
            <Col style={{ maxWidth: "523px" }}>
              <CustomTypoH1 typo={`Questions or Enquiries?`} />
              <CustomTypoH5 typo={`Our customer support team is available 7 days a week from 5 am to 8 pm with live chat or by phone.`} />
            </Col>
          </Row>
          <Row className='margin-top-60'>
            <Col sm={12} md={6} lg={6}>
              <CustomTypoH1 typo={'Take advantage of what Kardinal has to offer'} />
              <CustomTypoH5 typo={`Do you want to learn more about Kardinal and what we have to offer? Let our team show you around.`} />
              <NavLink to='/demo' className='NavLink-btn'>Request demo now</NavLink>
            </Col>
            <Col sm={12} md={6} lg={6} className='padding-left-per'>
              <CustomTypoH1 typo={'Email Support?'} />
              <CustomTypoH5 typo={`Send an email and get a response quickly.`} />
              <div className='link-list'>
                <NavLink to={"#"} onClick={navigateBook} className='NavLink-btn'>Booking</NavLink>
                <NavLink to='#' onClick={navigateSupport} className='NavLink-btn'>Support</NavLink>
                <NavLink to='#' onClick={navigateSales} className='NavLink-btn'>Sales</NavLink>
              </div>
            </Col>
          </Row>
          <Row className='margin-top-60'>
            <Col sm={12} md={6} lg={6}>
              <CustomTypoH1 typo={'Follow us on all platforms'} />
              <CustomTypoH5 typo={`Stay updated with all things Kardinal.`} />
              <div className='link-list'>
                <NavLink to='#' onClick={navigateLinkedin} className='NavLink-btn'>Linkedin</NavLink>
                <NavLink to='#' onClick={navigateTwitter} className='NavLink-btn'>Twitter</NavLink>
                <NavLink to='#' onClick={navigateInstagram} className='NavLink-btn'>Instagram</NavLink>
                <NavLink to='#' onClick={navigateFacebook} className='NavLink-btn'>Facebook</NavLink>
              </div>
            </Col>
            <Col sm={12} md={6} lg={6} className='padding-left-per'>
              <CustomTypoH1 typo={'Visit us'} />
              <CustomTypoH5 typo={`2a Alara street, Sabo Yaba, Lagos Nigeria.`} />
            </Col>
          </Row>
        </Container>
      </section>

      <section className='contact_section_3'>
        <ReqDemoAndSignupSection
          title={`Change the way you do business travel`}
          signUpBtn={'Sign up for free'}
          reqDemoBtn={`Request Demo`}
          signUpBtnMobile={`Sign up`}
        />
      </section>
    </div>
  );
};

export default ContactPage;